import { render, staticRenderFns } from "./privacyInfo.vue?vue&type=template&id=1afeff78&scoped=true&"
import script from "./privacyInfo.vue?vue&type=script&lang=js&"
export * from "./privacyInfo.vue?vue&type=script&lang=js&"
import style0 from "./privacyInfo.vue?vue&type=style&index=0&id=1afeff78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afeff78",
  null
  
)

export default component.exports